"use client";

import ColourComponent from "@JohnLewisPartnership/jl-design-system/dist/components/colour/Colour";
import ColourList from "@JohnLewisPartnership/jl-design-system/dist/components/colour/ColourList";
import Link from "next/link";
import { NextParsedUrlQuery } from "next/dist/server/request-meta";

export type Colour = {
  /**
   * A string representing the colour.
   */
  colour: string;
  /**
   * A boolean indicating whether the colour is available to order.
   */
  availableToOrder: boolean;
  /**
   * A string representing the colour swatch. It can also be null or undefined.
   */
  colourSwatch: string | null | undefined;
  /**
   * A string representing the canonical URL. It can also be null or undefined.
   */
  canonicalURL: string | null | undefined;
  /**
   * A boolean indicating whether to show the reduced label.
   */
  showReduced: boolean;
  /**
   * A string representing the reduced label. It can also be null or undefined.
   */
  reducedLabel: string | null | undefined;
  /**
   * A boolean indicating whether the colour is selected.
   */
  selected: boolean;
  /**
   * An object representing a colour's target url
   */
  url: {
    pathname: string;
    query: NextParsedUrlQuery;
  };
};

type Props = {
  /**
   * A number representing the rows to display.
   */
  rowsToDisplay: number;
  /**
   * An array of Colour objects.
   */
  uniqueColours: Colour[];
};

export const ColoursUI = ({ rowsToDisplay, uniqueColours }: Props) => {
  if (!uniqueColours || uniqueColours.length < 2) return null;

  const selectedColour = uniqueColours.find((c) => c.selected);

  return (
    <ColourList
      showMore={rowsToDisplay}
      data-testid="colour:option"
      selectedLabel={selectedColour?.colour}
    >
      {uniqueColours.map((colourOption, index) => {
        return (
          <span
            key={`span${index}`}
            title={colourOption.colour}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - ignored due to JLDS requirement to have it in children element
            value={colourOption.colour}
          >
            <ColourComponent
              key={`colourOption-${index}`}
              Tag={Link}
              buttonProps={{
                href: colourOption.url,
                shallow: true,
                scroll: false,
              }}
              selected={colourOption.colour === selectedColour?.colour}
              unavailable={
                !colourOption.availableToOrder
                // TODO: find out if this feature flag is still needed for isFutureRelease
                // ((!colourOption.isFutureRelease &&
                //   featureFlags.usePreOrders) ||
                //   !featureFlags.usePreOrders)
              }
              name="colourSelector"
              value={colourOption.colour}
              swatch={`${colourOption.colourSwatch}&wid=24&hei=24&fit=crop`}
              hasReducedPrice={colourOption.showReduced}
              reducedPriceText={colourOption.reducedLabel}
            />
          </span>
        );
      })}
    </ColourList>
  );
};
